
export const BASE_URL = 'https://backend-railway-production-1582.up.railway.app'